import React, { ReactNode } from 'react';
import styles from './style.module.scss';

interface IPropsLocation {
    name: string,
    sub_locations?: { name: string }[]
}

const getName = (value: IPropsLocation) => {
    let { name, sub_locations = [] } = value;
    return sub_locations.length > 0 ? [name, sub_locations.map(sub => sub.name).join(', ')].join(' - ') : name;
}

interface IProps {
    visible?: boolean
    className?: string
    separate?: string | ReactNode
    locations: IPropsLocation[]
}

const Locations2: React.FC<IProps> = (props) => {
    const { visible = true, className, separate = <span className='arrow-right' />, locations } = props;
    if (!visible || locations.length === 0)
        return null;

    const list = [<span key={0}>{getName(locations[0])}</span>];
    for (let i = 1; i < locations.length; i++) {
        list.push(<span key={i}>{separate}</span>);
        list.push(<span key={`location-${i}`}>{getName(locations[i])}</span>);
    }

    return <div className={[styles.locations, className].join(' ')}>
        {list}
    </div>;
};

export default Locations2;
